import React from 'react';

export function Header() {
  return (
    <header className="header">
      <img src="/icons/gvegg-logo.png" alt="GvE.gg" className="header-logo" />
    </header>
  );
}
